
import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="main-footer">
      <p>&copy; 2025 Nacho Pereira. All rights reserved.</p>
      <div className="social-links">
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">IG</a>
        <a href="https://soundcloud.com" target="_blank" rel="noopener noreferrer">SC</a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">TW</a>
      </div>
    </footer>
  );
}

export default Footer;
